import { createAction, props } from '@ngrx/store';

export const setTechChartSecurityGroup = createAction(
    '[Tech Chart] Set Chart Security Group',
    props<{ securityGroup: string }>()
);
